import script from "./MessageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageView.vue?vue&type=script&setup=true&lang=ts"

import "./MessageView.vue?vue&type=style&index=0&id=528b5655&scoped=true&lang=less"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528b5655"]])

export default __exports__